import {Show} from 'platform/foundation';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {CommentExpandable} from '../../components/CommentExpandable/CommentExpandable';
import {Section} from '../../components/Section/Section';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';

export function AdvertisementDescription() {
  const {advertisementDescription} = useGetOnlineOfferData();
  return (
    <Show when={isNotNilOrEmpty(advertisementDescription)}>
      <Section id="ADVERTISEMENT_DETAILS" isWithBreakLine>
        <CommentExpandable hideCommentFlag comment={advertisementDescription!} />
      </Section>
    </Show>
  );
}
